import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Icon, TextRegular, Box } from '@hz-design-system/web-ui';
import { ListingAttribute, ListingEnergyLabel } from '@/client/components/ListingsNew/components';
import formatAttributeBasedOnKey from '@/client/utils/formatters/formatBasedOnKey';
import { Attribute } from '@/client/types/Listings';

import Classes from './ListingAttributes.module.scss';

const SPACE_SEPARATOR = ' ';

interface ListingAttributesProps {
  regularAttributes: Attribute[];
  mileage?: Attribute;
  carPassUrl?: Attribute;
  napAvailable: boolean;
  energyLabel?: Attribute;
  tenantContext: any;
}

const ListingAttributes: React.FC<ListingAttributesProps> = ({
  regularAttributes,
  mileage,
  carPassUrl,
  napAvailable,
  energyLabel,
  tenantContext,
}) => {
  const { t } = useI18nContext();

  if (!(!!regularAttributes.length || mileage || carPassUrl || napAvailable || energyLabel)) {
    return null;
  }

  return (
    <Box as="div" name="attributes-wrapper" className={Classes['hz-Listing-attributes-wrapper']}>
      <Box as="div" name="attributes" className={Classes['hz-Listing-attributes']}>
        {energyLabel && <ListingEnergyLabel rating={energyLabel.value} tenantContext={tenantContext} />}
        {regularAttributes.map((attribute, key) => (
          <ListingAttribute type="default" key={key}>
            <TextRegular strong>
              {formatAttributeBasedOnKey(attribute.key, attribute.value, undefined, undefined)}
              {SPACE_SEPARATOR}
              {attribute.unit && attribute.unit}
            </TextRegular>
          </ListingAttribute>
        ))}
        {(mileage || carPassUrl || napAvailable) && (
          <Box as="div" name="attributes-nap-mileage">
            {mileage && (
              <ListingAttribute type="default">
                <TextRegular strong>
                  {formatAttributeBasedOnKey(mileage.key, mileage.value, undefined, undefined)}
                  {SPACE_SEPARATOR}
                  {mileage.unit && mileage.unit}
                </TextRegular>
                {napAvailable && (
                  <span title={t('listings.nap')}>
                    <Icon name="checkmark" color="success" />
                  </span>
                )}
                {carPassUrl && (
                  <span title={t('listings.carPass')}>
                    <Icon name="checkmark" color="text-link-default" />
                  </span>
                )}
              </ListingAttribute>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ListingAttributes;
